/**
 * Main layout component with sidebar navigation and content area.
 * Wraps all pages with consistent navigation structure.
 */

import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '../context/AuthContext';

export default function Layout() {
  const { loading, error } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading Homebase...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-screen">
        <h1>Authentication Error</h1>
        <p>{error}</p>
        <p className="error-hint">
          Make sure you're accessing Homebase through Cloudflare Access.
        </p>
      </div>
    );
  }

  return (
    <div className="app-container">
      <Sidebar />
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
